import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import immutableToJS from 'utils/immutableToJS';

import {
  currentServiceRequestSelector,
} from 'redux/serviceRequests/selectors';


/* istanbul ignore next */
const withConnectedData = (WrappedComponent) => {
  function Container(props) {
    return (
      <WrappedComponent {...props} />
    );
  }

  Container.propTypes = {
    serviceRequestInfo: PropTypes.shape({
      reasonForRepair: PropTypes.shape({
        code: PropTypes.string,
        description: PropTypes.string,
      }),
    }),
  };

  Container.defaultProps = {
    serviceRequestInfo: {},
  };

  function mapStateToProps(state) {
    return {
      serviceRequestInfo: currentServiceRequestSelector(state),
    };
  }

  return connect(mapStateToProps)(
    immutableToJS(Container),
  );
};

export default withConnectedData;



// WEBPACK FOOTER //
// ./compositions/ServiceRequestWidget/ServReqServReqInfoContainer.js